import { Navigate } from 'react-router-dom';
import React, { useContext } from 'react';
import DataContext from 'y4/context/DataContext';
import MainContentCard from './MainContentCard';
import _ from 'lodash';
import y, { getMenuPath } from 'y4/Utils';
import AppContext from 'context/Context';
import { isAuthorized } from 'y4/Authentication';
const Home = () => {
  const {
    config: { corp, home }
  } = useContext(AppContext);
  const { globalData } = useContext(DataContext);
  try {
    //ActionAfterLogin
    const sk = y.md5('ActionAfterLogin');
    const afl_s = y.getSessionItem(sk);
    if (afl_s) {
      //一个奇怪的现象，这个组件会加载两次，如果第一次就清空了，没有达到跳转的目的
      setTimeout(() => {
        y.removeSessionItem(sk);
      }, 5000);

      const afl = JSON.parse(afl_s);
      if (afl?.to) {
        return <Navigate to={afl.to} />;
      }
    }
    if (isAuthorized(corp)) {
      //-----------------------------------begin
      //To fix error,remerber password but no menu info,then navigate home error page
      if (y.isEmpty(globalData.menu)) {
        y.clearSession();
        y.clearLocal();
        return <Navigate to={`/${corp}`} />;
      }
      //-----------------------------------end
      const h = globalData.menu[0].children[0].children[0].to;
      if (_.isEmpty(h) || h == '/') {
        return (
          <MainContentCard title="Home error">
            Can't set home to '/' or empty.
          </MainContentCard>
        );
      } else {
        return <Navigate to={getMenuPath(corp, h)} />;
      }
    } else {
      const h = home ?? process.env.REACT_APP_LOGIN_PATH;
      if (y.isFullUrl(h)) {
        window.location.replace(h);
        return null;
      } else {
        return <Navigate to={`/${corp}${h}`} />;
      }
    }
  } catch (error) {
    return <MainContentCard title="Home error">No home page</MainContentCard>;
  }
};
export default Home;
